import React, { FC } from 'react';
import { CircularProgress, Button as MuiButton, ButtonProps as MuiButtonProps } from '@mui/material';
import './index.css';

interface ButtonProps extends MuiButtonProps {
    loading?: boolean;
};

const Button: FC<ButtonProps> = ({ children, onClick = () => { }, disabled = false, loading = false, ...props }) => {
    return (
        <MuiButton
            onClick={onClick}
            disabled={disabled}
            {...props}
            startIcon={loading ? <CircularProgress color="secondary" size={20} style={{ display: loading ? 'block' : 'none' }} /> : props.startIcon}
        >
            {children}
        </MuiButton>
    );
};

export default Button;
